import { once } from '@/shared/utils/once';
import axios from 'axios';

export interface Config {
    BASE_API_URL: string
}

class Environment {
    readonly baseUrl = process.env.BASE_URL
    readonly mode = process.env.NODE_ENV
    readonly silent = process.env.NODE_ENV === 'production' || process.env.VUE_APP_SILENT

    getBaseApiUrl(): Promise<string> {
        return Promise.resolve(process.env.VUE_APP_BASE_API_URL)
    }
}

export const environment = new Environment()
